import Section from "../Section";
import image6 from "../../assest/Nikea/images/image6.jpeg";
import k2investpagebgcover from "../../assest/GreenHome/images/k2investpagebgcover.JPG";
import LogoSVG from "../SVG/LogoSVG";
import { innerRenderPaths } from "../../assest/imgPaths";

const SecondSection = () => {
  return (
    <Section bg="bg-inherit">
      <div className="flex flex-col items-center md:items-start justify-center col-span-full md:col-span-10 md:col-start-2 md:grid md:grid-cols-9 md:grid-rows-1 gap-16 py-16 xl:py-32 xl:h-screen/80">
        <div className="hidden xl:block col-span-3 bg-black rounded-xl h-96">
          <img
            src={image6}
            alt="K2 Invest group"
            loading="lazy"
            className="h-96 w-full object-cover opacity-70 rounded-xl"
          />
        </div>
        <div className=" w-screen md:w-auto px-4 md:col-span-8 grid-row-1 xl:col-span-4 xl:col-start-4 flex flex-col items-stretch justify-between gap-8 xl:gap-0 xl:py-0 ">
          <p className="flex flex-col items-center justify-around italic text-primary-bg-blue h-full md:text-xl font-normal tracking-wider uppercase">
            <span>
              როგორც მაღალი პასუხისმგებლობის მქონე ბრენდის მთავარი მიზანია,
              ქუთაისის უბნებში ისეთი საცხოვრებელი სახლების შენება, რომელიც
              იქნება ეკოლოგიურად სუფთა, ახალი არქიტექტურული სტილის მქონე და
              უმაღლესი ხარისხის.
            </span>
            <span>
              დეველოპერულ კომპანია K2 invest- ს, გააჩნია ზუსტი და თანმიმდევრულად
              გაწერილი განვითარების გეგმა, რომელიც დაფუძნებულია
              პროფესიონალიზმზე, მაღალ ხარისხზე და მაღალ სოციალურ
              პასუხისმგებლობაზე.
            </span>
          </p>
        </div>
        <div className="w-screen md:w-auto xl:place-self-end px-4 md:col-span-8 xl:col-span-2 rounded-xl flex items-end justify-end">
          <div className="bg-black max-h-fit w-full rounded-xl">
            <img
              src={innerRenderPaths[11]}
              alt="K2 Invest group"
              loading="lazy"
              className="h-56 w-full object-cover opacity-90 rounded-xl"
            />
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${k2investpagebgcover})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        className="col-span-full py-16 md:min-h-[80vh] xl:min-h-screen flex flex-col items-center justify-center gap-12 px-3 md:px-32 xl:px-60 bg-linear-to-bl from-black to-blue-800 text-primary-light "
      >
        <h2 className="text-xl sm:text-3xl xl:text-5xl text-center font-gilroy tracking-wider leading-loose">
          კეთილი იყოს თქვენი მობრძანება <br />
          <span className="font-semibold text-primary-orange leading-loose xl:tracking-widest flex items-center justify-center">
            <LogoSVG w={60} h={35} />{" "}
            <span className="text-primary-light ml-2">ინვესტში</span>
          </span>
        </h2>
        <div className="font-mono flex flex-col items-start justify-between gap-6 w-full text-sm sm:text-base tracking-wide leading-relaxed text-center md:text-left">
          <p className="italic text-left">
            <q className="text-primary-orange text-lg">
              <span className="text-primary-bg-light text-sm ">
                ჩემი ცხოვრების გარკვეული ნაწილი ევროპის სხვადასხვა ქვეყნებში
                მოგზაურობას და ცხოვრებას დავუთმე. ევროპაში გატარებულმა დღეებმა
                საშუალება მომცა დავკვირვებოდი ადგილობრივების ცხოვრების წესს ,
                მათ კულტურას და გარემო-პირობების გავლენას მათ ცხოვრებაზე. უამრავ
                სიახლესთან ერთად რასაც იქ შევიმეცნებდი, განსაკუთრებულ
                შთაბეჭდილებას ახდენდა განსხვავებული სტილის არქიტექტურა.
                <br />
                <br /> საბოლოო ჯამში არქიტექტურა ჩემი გატაცება გახდა. ბევრს
                ვკითხულობდი და ვუყურებდი უამრავ არქიტექტურული შინაარსის მქონე
                სიუჟეტებს. საქართველოში დაბრუნების მთავარ მოტივად იქცა ის რომ
                ჩემი გატაცება ჩემს ძირითად საქმიანობად მექცია. ასე დაიბადა იდეა,
                რომ ჩემს მშობლიურ ქალაქ ქუთაისში მეშენებინა თანამედროვე ტიპის
                საცხოვრებელი სახლები.
                <br /> <br /> პირველი გამოცდილება ამ კუთხით ჩემივე სახლის
                დაპროექტებით და აშენებით მივიღე და მივხვდი, სწორად დასახულ
                მიზანს აუცილებლად მიყავხარ სასურველ შედეგამდე. დამეთანხმებით,
                რომ სახლი უმთავრეს მატერიალურ შენაძენად მიიჩნევა და ამიტომ მისი
                ყიდვისთვის ადამიანებს ბევრი და ხანგრძლივი შრომა უწევთ.
                შესაბამისად, ჩვენი როგორც მაღალი პასუხისმგებლობის მქონე ბრენდის
                -მთავარი მიზანი გახდა, ქუთაისის უბნებში ისეთი საცხოვრებელი
                სახლების შენება, რომელიც იქნებოდა ეკოლოგიურად სუფთა, ახალი
                არქიტექტურული სტილის მქონე და რაც მთავარია უმაღლესი ხარისხით და
                დაპირებულ დროში, რათა ადამიანების ნდობა გაგვემართლებინა. <br />
                <br />
                სრული პასუხისმგებლობით მინდა განვაცხადო, რომ დეველოპერულ
                კომპანია K2 invest- ს, გააჩნია ზუსტი და თანმიმდევრულად გაწერილი
                განვითარების გეგმა, რომელიც დაფუძნებულია პროფესიონალიზმზე, მაღალ
                ხარისხზე და მაღალ სოციალურ პასუხისმგებლობაზე. მადლობას გადავუხდი
                K2 Invest-ის ყველა მობინადრეს ნდობისთვის.
              </span>
            </q>
          </p>

          <br />

          <span className="place-self-end text-base flex flex-col items-center justify-end">
            K2 Invest-ის გენერალური დირექტორი <br />{" "}
            <span className="place-self-end italic">გიორგი კვიტივაძე</span>
          </span>
        </div>
        {/* 
        <a
          href="/company-view"
          className="relative text-primary-light uppercase text-lg flex flex-col items-center justify-center font-bold tracking-wider  bg-transparent no-underline opacity-100 transform  transition-all duration-[0.45s] ease-out delay-[0.6s] whitespace-nowrap cursor-pointer group"
        >
          იხილეთ სრულად
          <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-light transition-all duration-500 group-hover:w-full"></span>
        </a> */}
      </div>
    </Section>
  );
};

export default SecondSection;
